// extracted by mini-css-extract-plugin
module.exports = {"header":"products_header__2zf4k","table":"products_table__2P6ro","emptyTips":"products_emptyTips__11cdC","img":"products_img__1jBhU","text":"products_text__3BvIO"};